import { render } from "./SectionHeadline.vue?vue&type=template&id=a15bddc2"
import script from "./SectionHeadline.vue?vue&type=script&lang=js"
export * from "./SectionHeadline.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__